import cn from "classnames";
import {getFontClassByDigits} from "@game/ui/uiHelpers";
import {tickup} from "@game/ui/components/CoinsIndicator/helper";
import {UIConstants} from "@game/ui/constants";
import {useLayoutEffect, useState} from "preact/hooks";
import {ComponentClassName} from "@dp-instant/ui";

type CoinsFieldProps = {
    total?: number;
    className?: string;
    tickupDuration?: number;
} & ComponentClassName;

export const CoinsField = ({
    total = 0,
    className,
    tickupDuration = UIConstants.coinsIndicator.updateDelay
}: CoinsFieldProps) => {
    const [state, setState] = useState(total);
    if (tickupDuration) {
        useLayoutEffect(
            () => tickup(state, total, tickupDuration, (val: any) => setState(Math.round(val))),
            [total]
        );
    }
    return <div className={cn("coins-field", className, getFontClassByDigits(state))}>{state}</div>;
};
